import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { GaTrackingEventLabel, GATrackingEventType } from '~shared/modules/ga-tracking/constants';

export class ZRPOtherBucketClickedApplicationEventModel implements ApplicationEvent {
  type = ApplicationEventType.Search_ZRP_other_buckets_clicked;

  constructor(private action: GATrackingEventType, private element: GaTrackingEventLabel | string) {}

  getPayload(): any {
    return {
      action: this.action,
      element: this.element,
    };
  }
}
